import gsap from "gsap";

export default function aboutAnimation() {
	return gsap.timeline({
		scrollTrigger: {
			trigger: '.js-about-cases',
			start: 'top top',
			end: '+=50%',
			scrub: true
		}
	})
		.fromTo('.js-about-spring', {
			yPercent: 0,
			opacity: .6
		}, {
			yPercent: 30,
			opacity: 0
		})
}
